import DropdownIcon from 'assets/img/down-arrow-white.png';

const DropdownIndicatorIcon = () => {
    return (
        <img className='dropdownIcon' alt="Dropdown Icon" src={DropdownIcon} />
    )
};

export default DropdownIndicatorIcon;
